import { computed, ref } from 'vue';

const IS_LOADING = 'loading';
const IS_LOADED = 'loaded';

export default function useLoading(defaultState = IS_LOADING) {
  const loadingState = ref(defaultState);
  const isLoading = computed(() => loadingState.value === IS_LOADING);
  const isLoaded = computed(() => loadingState.value === IS_LOADED);

  const startLoading = () => loadingState.value = IS_LOADING;
  const stopLoading = () => loadingState.value = IS_LOADED;

  return {
    isLoading,
    isLoaded,
    startLoading,
    stopLoading,
  };
}
